import { Market, MarketNode } from "tm-shared/types";
import { arrayToRecord } from "tm-shared/utils";

export const buildMarketChains = (markets: Market[]): MarketNode[] => {
    const marketMap: Record<string, MarketNode> = arrayToRecord(
        markets.map((market) => ({ ...market })),
        "id",
    );

    const childIds = new Set<string>();

    for (const market of markets) {
        const parentId = market.parentInfo!.parentId;

        if (!parentId) continue;

        const parent = marketMap[parentId];
        const current = marketMap[market.id];

        parent.child = current;
        childIds.add(current.id);
    }

    return Object.values(marketMap).filter(
        (market) => !childIds.has(market.id),
    );
};
